import {SHOWHOST} from '../config'

const requestUrl = SHOWHOST
/**
 * 获取Token
 */
export const getToken = () => {
    let token = window.localStorage.getItem('token')
    // return  token ? token : ''
    return token ? JSON.parse(token) : ''
}

/*
 * 百度编辑器配置
 * */
export const bdEditConfig = () => {
    return {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 320,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        // serverUrl: requestUrl + '/editor/controller.php',
        serverUrl: requestUrl + '/static/ueditor/php/controller.php',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/UEditor/'
    }
}


/*
 *
 * */
export const payYears = [{
    value: 1,
    label: '1年'
}, {
    value: 2,
    label: '2年'
}, {
    value: 3,
    label: '3年'
}, {
    value: 4,
    label: '4年'
}, {
    value: 5,
    label: '5年'
}, {
    value: 6,
    label: '6年'
}]
/*
 *北京-区
 * */
export const address = [
    {value: 0, label: '全部'},
    {value: 1, label: '东城区'},
    {value: 2, label: '西城区'},
    {value: 3, label: '朝阳区'},
    {value: 4, label: '海淀区'},
    {value: 5, label: '丰台区'},
    {value: 6, label: '石景山区'},
    {value: 7, label: '门头沟区'},
    {value: 8, label: '房山区'},
    {value: 9, label: '通州区'},
    {value: 10, label: '顺义区'},
    {value: 11, label: '昌平区'},
    {value: 12, label: '大兴区'},
    {value: 13, label: '怀柔区'},
    {value: 14, label: '平谷区'},
    {value: 15, label: '密云区'},
    {value: 16, label: '延庆区'},
]

/*
 *单位性质
 * */
export const nature = [
    {value: 0, label: '全部'},
    {value: 1, label: '机关'},
    {value: 2, label: '事业单位'},
    {value: 3, label: '国有企业'},
    {value: 4, label: '民营企业'},
    {value: 5, label: '社会团体'},
    {value: 6, label: '民办非企业单位'},
    {value: 7, label: '基金会'},
    {value: 8, label: '其他'},
]

export const payList = [
    {value: 0, label: '全部'},
    {value: 1, label: '未缴费'},
    {value: 2, label: '已缴费'}
]

/*
 *会员等级
 * */
export const level = [
    {value: 0, label: '全部'},
    {value: 1, label: '会员单位'},
    {value: 2, label: '会员代表单位'},
    {value: 3, label: '理事单位'},
    {value: 4, label: '常务理事单位'},
    {value: 5, label: '副会长单位'},
    {value: 6, label: '监事单位'},
    {value: 7, label: '监事长单位'},
]
/*
 *是否新会员
 * */
export const newMember = [
    {value: 0, label: '否'},
    {value: 1, label: '是'}
]

/*
 *会员分类
 * */
export const memberType = [
    {value: 0, label: '全部'},
    {value: 1, label: '供给侧会员', desc: '（提供社会化消防服务）'},
    {value: 2, label: '需求侧会员', desc: '（需要社会化消防服务）'},
]
/*
 *会员供给分类
 * */
export const supply = [
    {value: 0, label: '全部'},
    {value: 1, label: '建筑防火', desc: '指从事建设工程消防设计、施工、监理、审核、验收、建筑材料检验检测等服务的单位会员。'},
    {value: 2, label: '消防产品', desc: '指从事消防产品（含消防器材、装备、设备）研发、生产、销售、维修、鉴定检验检测等服务的单位会员。'},
    {value: 3, label: '消防设施', desc: '指从事消防设施安装、检测、维保、监测等服务的单位会员。'},
    {value: 4, label: '安全评估', desc: '指从事单位火灾风险评估、区域消防安全形势分析评估等服务的单位会员。'},
    {value: 5, label: '宣传教育培训', desc: '指从事一般化消防宣传教育、职业化消防技能培训、社会化消防安全教育培训等服务的单位会员。'},
    {value: 6, label: '消防信息化', desc: '指从事消防远程监控、消防物联网、消防安全信息化管理、智慧消防等服务的单位会员。'},
    {value: 7, label: '电气防火', desc: '指从事电气防火检测、电气火灾监控等服务的单位会员。'},
    {value: 8, label: '排油烟设施清洗', desc: '指从事餐饮场所排油烟设施清洗、清洗设备研发等服务的单位会员。'},
    {value: 9, label: '灭火救援', desc: '指从事社会化火灾扑救、应急救援、社会救助等服务的单位会员。'},
    {value: 10, label: '事故调查', desc: '指在火灾事故、生产安全事故调查过程中，为事故单位或调查机构提供技术分析、物证检验鉴定等服务的单位会员。'},
    {value: 11, label: '法规政策', desc: '指从事消防法规、行政规范性文件、消防技术标准研究、咨询，以及制定、修订辅助工作；从事消防法律顾问，消防民事、行政、刑事案件诉讼代理等服务的单位会员。'},
    {value: 12, label: '消防保险', desc: '指从事火灾财产险、人身险、公众责任险等各类消防相关保险评估、承保、理赔、参与事故调查等服务的单位会员。'},
    {value: 13, label: '消防安全检查', desc: '指从事日常消防安全检查、公众聚集场所开业或投入使用前消防安全检查、大型活动举办前消防安全检查、专项消防安全检查等社会化服务的单位会员。'},
    {value: 14, label: '其他', desc: ''},
]

/*
 *会员需求分类
 * */
export const demand = [
    {value: 0, label: '全部'},
    {value: 1, label: '住宿业', desc: '指酒店、宾馆、饭店、招待所、民宿、旅游度假村等从事住宿业的单位会员。'},
    {value: 2, label: '餐饮业', desc: '指对公众开放的餐饮场所、单位内部食堂(单位内设机构名义入会）等单位会员。'},
    {value: 3, label: '仓储业', desc: '指从事专为他人储藏、保管货物服务的物流基地、专用库房等单位会员。'},
    {value: 4, label: '建筑业', desc: '指建设工程的建设单位、设计单位、施工单位、监理单位等从事土木工程、房屋建设和设备安装以及工程勘察设计工作的单位会员。'},
    {value: 5, label: '制造业', desc: '指劳动密集型、技术密集型企业等从事产品制造的单位会员。'},
    {value: 6, label: '文体业', desc: '指文化馆、博物馆、展览馆、影剧院、体育场馆、歌舞厅、酒吧等从事文化、体育和公共娱乐活动的单位会员。'},
    {value: 7, label: '商市场', desc: '指商场、市场、商店，以及设有商场的大型商业综合体等单位会员。'},
    {value: 8, label: '物业服务', desc: '指为居民住宅、商业、办公场所提供物业服务的单位会员。'},
    {value: 9, label: '文物保护', desc: '指全国重点文物保护单位、省级文物保护单位和市县级文物保护单位等单位会员。'},
    {value: 10, label: '教育机构', desc: '指各类学校、幼儿园、教育培训机构等单位会员。'},
    {value: 11, label: '医疗机构', desc: '指医院、卫生院、疗养院、门诊部、诊所、急救中心、社区卫生服务中心、护理院等依法登记并取得《医疗机构执业许可证》的单位会员。'},
    {value: 12, label: '养老机构', desc: '指为老年人提供集中居住和照料服务的敬老院、福利院、养老院、老年公寓、养老服务中心等单位会员。'},
    {value: 14, label: '储能行业', desc: '指电化学储能及充换电设施应用行业消防服务相关的单位会员。'},
    {value: 15, label: '交通运输业', desc: '--'},
    {value: 16, label: '保安行业', desc: '--'},
    {value: 13, label: '其他', desc: ''},
]
/*
 *介绍人等级
 * */
export const introduce = [
    {value: 0, label: '全部'},
    {value: 1, label: '无'},
    {value: 2, label: '会员单位'},
    {value: 3, label: '会员代表单位'},
    {value: 4, label: '理事单位'},
    {value: 5, label: '常务理事单位'},
    {value: 6, label: '副会长单位'},
    {value: 7, label: '监事单位'},
    {value: 8, label: '监事长单位'},
    {value: 9, label: '秘书处'},
]

/*
 *   角色
 * */
export const powerList = [
    {value: 0, label: '超级管理员'},
    {value: 1, label: '经办人'},
    {value: 2, label: '审核人'},
    {value: 3, label: '审批人'},
    {value: 4, label: '查询人员'},

]

/*
 *   状态
 * */
export const applyList = [
    {value: 0, label: '全部'},
    {value: 5, label: '制证中'},
    {value: 6, label: '待领取'},
    {value: 7, label: '已发放'},
    {value: 11, label: '已过期'},
    {value: 12, label: '已退会'}
]

/*
 *   状态
 * */
export const examineList = [
    {value: 0, label: '全部审核进度'},
    {value: 1, label: '经办人审核'},
    {value: 2, label: '审核人审核'},
    {value: 3, label: '审批人审核'},
    {value: 4, label: '审核驳回'},

]

/**
 *
 * @param {*} 转化
 * @param {*} arr
 * @returns
 */
export const conversionList = [
    {value: '', label: '全部进程'},
    {value: 2, label: '审批中'},
    {value: 0, label: '未入会'},
    {value: 1, label: '已入会'},

]

/**
 *
 * @param {*} 反馈情况
 * @param {*} arr
 * @returns
 */
export const feedbackList = [
    {value: 0, label: '全部'},
    {value: 2, label: '未反馈'},
    {value: 1, label: '已反馈'},

]

/**
 * 缴费状态
 */

export const feeList = [
    {value: 0, label: '全部'},
    {value: 1, label: '审核通过未缴费'},
    {value: 2, label: '已缴费'},
    {value: 3, label: '已到期'},
]

export const feeList2 = [
    {value: 0, label: '全部'},
    {value: 1, label: '审核通过/未缴费'},
    {value: 2, label: '已缴费/有效期内'},
    {value: 3, label: '到期/未退会'},
    {value: 4, label: '已退会数据'},
]

//注册资本
export const moneyList = [
    {value: '', label: '全部'},
    {value: 1, label: '50万以内'},
    {value: 2, label: '50-200万'},
    {value: 3, label: '200-500万'},
    {value: 4, label: '500-1000万'},
    {value: 5, label: '1000万以上'},
    {value: 0, label: '无'},
]

//连续经营年限
export const jYearList = [
    {value: '', label: '全部'},
    {value: 1, label: '一年'},
    {value: 2, label: '两年-五年'},
    {value: 3, label: '五年-十年'},
    {value: 4, label: '十年以上'},
]

//消防技术服务从业条件
export const serviceList = [
    {value: '', label: '全部'},
    {value: 1, label: '消防安全评估'},
    {value: 2, label: '消防设施维护保养检测'},
    {value: 0, label: '无'},
]

//信息类相关资质及证书
export const informationQualificationList = [
    {value: '', label: '全部'},
    {value: 1, label: '计算机信息系统集成资质'},
    {value: 2, label: '涉密信息系统集成资质'},
    {value: 3, label: '信息安全服务资质认证'},
    {value: 7, label: '其他'},
    {value: 0, label: '无'},
]
//教育培训类相关资质及证书
export const educationTrainingList = [
    {value: '', label: '全部'},
    {value: 1, label: '办学校办学许可证'},
    {value: 7, label: '其他'},
    {value: 0, label: '无'},
]

//排油烟大气环保相关资质及证书
export const lampblackList = [
    {value: '', label: '全部'},
    {value: 1, label: '中国环保产品CEPP认证'},
    {value: 2, label: '其他相关认证'},
    {value: 0, label: '无'},
]
//消防产品相关资质及证书
export const fireProductList = [
    {value: '', label: '全部'},
    {value: 1, label: '强制性认证（中国国家强制性产品认证证书）'},
    {value: 2, label: '自愿性认证（消防产品认证证书）'},
    {value: 3, label: '技术鉴定（消防产品技术鉴定证书）'},
    {value: 4, label: '其他类检测报告'},
    {value: 0, label: '无'},
]
//建筑、消防施工资质
export const zizhiList = [
    {value: '', label: '全部'},
    {value: 1, label: '消防设施工程专业承包资质一级'},
    {value: 2, label: '消防设施工程专业承包资质二级'},
    {value: 3, label: '消防设施工程设计与施工资质一级'},
    {value: 4, label: '消防设施工程设计与施工资质二级'},
    {value: 5, label: '消防设施工程设计专项甲级'},
    {value: 6, label: '消防设施工程设计专项乙级'},
    {value: 7, label: '其他与消防相关的资质'},
    {value: 0, label: '无'},
]

//主营消防产品及特点
export const productList = [
    {value: '', label: '全部'},
    {
        value: 1, label: '1.火灾报警产品', children: [
            {
                value: 1, label: '1.火灾探测报警产品(强制性认证产品)', children: [
                    {value: 1, label: '1.点型感烟火灾探测器(强制性认证产品)'},
                    {value: 2, label: '2.点型感温火灾探测器(强制性认证产品)'},
                    {value: 3, label: '3.独立式感烟火灾探测报警器(强制性认证产品)'},
                    {value: 4, label: '4.特种火灾探测器(强制性认证产品)'},
                    {value: 5, label: '5.点型紫外火焰探测器(强制性认证产品)'},
                    {value: 6, label: '6.线型光束感烟火灾探测器(强制性认证产品)'},
                    {value: 7, label: '7.手动火灾报警按钮(强制性认证产品)'},
                    {value: 8, label: '8.点型复合式感烟感温火灾探测器(强制性认证产品)'},
                    {value: 9, label: '9.线型感温火灾探测器(自愿性认证产品)'},
                ]
            },
            {
                value: 2, label: '2.火灾报警控制器(强制性认证产品)', children: [
                    {value: 1, label: '1.火灾报警控制器(强制性认证产品)'},
                ]
            },
            {
                value: 3, label: '3.火灾声和/或光警报器(强制性认证产品)', children: [
                    {value: 1, label: '1.火灾声光报警器(强制性认证产品)'},
                ]
            },
            {
                value: 4, label: '4.火灾显示盘(强制性认证产品)', children: [
                    {value: 1, label: '1.火灾显示盘(强制性认证产品)'},
                ]
            },
            {
                value: 5, label: '5.家用火灾报警产品(强制性认证产品)', children: [
                    {value: 1, label: '1.家用火灾报警控制器(强制性认证产品)'},
                    {value: 2, label: '2.点型家用感烟火灾探测器(强制性认证产品)'},
                    {value: 3, label: '3.点型家用感温火灾探测器(强制性认证产品)'},
                    {value: 4, label: '4.燃气管道专用电动阀(强制性认证产品)'},
                    {value: 5, label: '5.手动报警开关(强制性认证产品)'},
                    {value: 6, label: '6.家用火灾控制中心监控设备(强制性认证产品)'},
                ]
            },
            {
                value: 6, label: '6.消防联动控制系统设备(自愿性认证产品)', children: [
                    {value: 1, label: '1.消防联动控制器(自愿性认证产品)'},
                    {value: 2, label: '2.气体灭火控制器(自愿性认证产品)'},
                    {value: 3, label: '3.消防电气控制装置(自愿性认证产品)'},
                    {value: 4, label: '4.消防设备应急电源(自愿性认证产品)'},
                    {value: 5, label: '5.消防应急广播设备(自愿性认证产品)'},
                    {value: 6, label: '6.消防电话(自愿性认证产品)'},
                    {value: 7, label: '7.传输设备(自愿性认证产品)'},
                    {value: 8, label: '8.消防控制室图形显示装置(自愿性认证产品)'},
                    {value: 9, label: '9.消防电动装置(自愿性认证产品)'},
                    {value: 10, label: '10.消火栓按钮(自愿性认证产品)'},
                    {value: 11, label: '11.模块(自愿性认证产品)'},
                ]
            },
            {
                value: 7, label: '7.城市消防远程监控设备(自愿性认证产品)', children: [
                    {value: 1, label: '1.用户信息传输装置(自愿性认证产品)'},
                ]
            },
            {
                value: 8, label: '8.电气火灾监控设备(自愿性认证产品)', children: [
                    {value: 1, label: '1.电气火灾监控设备(自愿性认证产品)'},
                    {value: 2, label: '2.剩余电流式电气火灾监控探测器(自愿性认证产品)'},
                ]
            },
            {
                value: 9, label: '9.可燃气体报警产品(自愿性认证产品)', children: [
                    {value: 1, label: '1.可燃气体报警控制器(自愿性认证产品)'},
                    {value: 2, label: '2.可燃气体探测器(自愿性认证产品)'},
                ]
            },
            {
                value: 10, label: '10.防火卷帘控制器(自愿性认证产品)', children: [
                    {value: 1, label: '1.防火卷帘控制器(自愿性认证产品)'},
                ]
            },
            {
                value: 11, label: '11.其他类报警产品(技术鉴定产品)', children: [
                    {value: 1, label: '1.电动车锂电池（箱）火灾防控产品(技术鉴定产品)'},
                    {value: 2, label: '2.电动自行车蓄电池火灾预警装置(技术鉴定产品)'},
                ]
            },
        ]
    },
    {
        value: 2, label: '2.消防车', children: [
            {
                value: 1, label: '1.灭火消防车', children: [
                    {value: 1, label: '1.水罐消防车(自愿性认证产品)'},
                    {value: 2, label: '2.供水消防车(自愿性认证产品)'},
                    {value: 3, label: '3.泡沫消防车(自愿性认证产品)'},
                    {value: 4, label: '4.干粉消防车(自愿性认证产品)'},
                    {value: 5, label: '5.干粉泡沫联用消防车(自愿性认证产品)'},
                    {value: 6, label: '6.干粉水联用消防车(自愿性认证产品)'},
                    {value: 7, label: '7.气体消防车(自愿性认证产品)'},
                    {value: 8, label: '8.压缩空气泡沫消防车(自愿性认证产品)'},
                    {value: 9, label: '9.泵浦消防车(自愿性认证产品)'},
                    {value: 10, label: '10.高倍泡沫消防车(自愿性认证产品)'},
                    {value: 11, label: '11.水雾消防车(自愿性认证产品)'},
                    {value: 12, label: '12.机场消防车(自愿性认证产品)'},
                    {value: 13, label: '13.涡喷消防车'},
                    {value: 14, label: '14.高压射流消防车'},
                    {value: 15, label: '15.远程供水泵浦消防车'},
                ]
            },
            {
                value: 2, label: '2.举高消防车', children: [
                    {value: 1, label: '1.登高平台消防车(自愿性认证产品)'},
                    {value: 2, label: '2.云梯消防车(自愿性认证产品)'},
                    {value: 3, label: '3.举高喷射消防车(自愿性认证产品)'},
                    {value: 4, label: '4.破拆消防车'},
                ]
            },
            {
                value: 3, label: '3.专勤消防车', children: [
                    {value: 1, label: '1.通信指挥消防车(自愿性认证产品)'},
                    {value: 2, label: '2.抢险救援消防车(自愿性认证产品)'},
                    {value: 3, label: '3.化学救援消防车(自愿性认证产品)'},
                    {value: 4, label: '4.输转消防车(自愿性认证产品)'},
                    {value: 5, label: '5.照明消防车(自愿性认证产品)'},
                    {value: 6, label: '6.排烟消防车(自愿性认证产品)'},
                    {value: 7, label: '7.洗消消防车(自愿性认证产品)'},
                    {value: 8, label: '8.侦检消防车(自愿性认证产品)'},
                    {value: 9, label: '9.特种底盘消防车'},
                ]
            },
            {
                value: 4, label: '4.保障消防车', children: [
                    {value: 1, label: '1.器材消防车'},
                    {value: 2, label: '2.供气消防车'},
                    {value: 3, label: '3.供液消防车'},
                    {value: 4, label: '4.自装卸式消防车'},
                ]
            },
        ]
    },
    {
        value: 3, label: '3.消防装备产品', children: [
            {
                value: 1, label: '1.消防员个人防护装备(自愿性认证产品)', children: [
                    {value: 1, label: '1.正压式消防空气呼吸器(自愿性认证产品)'},
                    {value: 2, label: '2.正压式消防氧气呼吸器(自愿性认证产品)'},
                    {value: 3, label: '3.消防头盔(自愿性认证产品)'},
                    {value: 4, label: '4.消防员灭火防护头套(自愿性认证产品)'},
                    {value: 5, label: '5.消防手套(自愿性认证产品)'},
                    {value: 6, label: '6.消防员灭火防护靴(自愿性认证产品)'},
                    {value: 7, label: '7.消防员灭火防护服(自愿性认证产品)'},
                    {value: 8, label: '8.消防员隔热防护服(自愿性认证产品)'},
                    {value: 9, label: '9.消防员化学防护服(自愿性认证产品)'},
                    {value: 10, label: '10.消防腰斧(自愿性认证产品)'},
                    {value: 11, label: '11.消防员呼救器(自愿性认证产品)'},
                    {value: 12, label: '12.安全绳(自愿性认证产品)'},
                    {value: 13, label: '13.安全带(自愿性认证产品)'},
                    {value: 14, label: '14.安全钩(自愿性认证产品)'},
                    {value: 15, label: '15.上升器(自愿性认证产品)'},
                    {value: 16, label: '16.下降器(自愿性认证产品)'},
                    {value: 17, label: '17.抓绳器(自愿性认证产品)'},
                    {value: 18, label: '18.便携式固定装置(自愿性认证产品)'},
                    {value: 19, label: '19.滑轮装置(自愿性认证产品)'},
                    {value: 20, label: '20.长管空气呼吸器'},
                    {value: 21, label: '21.抢险救援靴'},
                    {value: 22, label: '22.消防员降温背心'},
                    {value: 23, label: '23.消防员避火服'},
                    {value: 24, label: '24.消防用防坠落装备'},
                    {value: 25, label: '25.消防员接触式送受话器'},
                    {value: 26, label: '26.消防员方位灯'},
                    {value: 27, label: '27.消防员配戴式防爆照明灯'},
                ]
            },
            {
                value: 2, label: '2.消防摩托车(自愿性认证产品)', children: [
                    {value: 1, label: '1.二轮消防摩托车'},
                    {value: 2, label: '2.三轮消防摩托车'},
                ]
            },
            {
                value: 3, label: '3.抢险救援产品(自愿性认证产品)', children: [
                    {value: 1, label: '1.消防斧(自愿性认证产品)'},
                    {value: 2, label: '2.消防救生气垫(自愿性认证产品)'},
                    {value: 3, label: '3.消防梯(自愿性认证产品)'},
                    {value: 4, label: '4.消防移动式照明装置(自愿性认证产品)'},
                    {value: 5, label: '5.消防救生照明线(自愿性认证产品)'},
                    {value: 6, label: '6.移动式消防排烟机(自愿性认证产品)'},
                    {value: 7, label: '7.手动破拆工具'},
                    {value: 8, label: '8.液压破拆工具'},
                    {value: 9, label: '9.破拆机具'},
                    {value: 10, label: '10.消防用红外热像仪'},
                    {value: 11, label: '11.消防用雷达生命探测仪'},
                    {value: 12, label: '12.消防用开门器'},
                    {value: 13, label: '13.救生抛投器'},
                    {value: 14, label: '14.消防救援支架'},
                    {value: 15, label: '15.消防用堵漏器材'},
                    {value: 16, label: '16.消防用输转器材'},
                    {value: 17, label: '17.消防用洗消器材'},
                    {value: 18, label: '18.消防用核生化侦检器材'},
                    {value: 19, label: '19.消防用水域救援器材'},
                ]
            },
            {
                value: 4, label: '4.消防机器人', children: [
                    {value: 1, label: '1.灭火机器人'},
                    {value: 2, label: '2.排烟机器人'},
                    {value: 3, label: '3.侦察机器人'},
                    {value: 4, label: '4.洗消机器人'},
                    {value: 5, label: '5.照明机器人'},
                    {value: 6, label: '6.救援机器人'},
                ]
            },
        ]
    },
    {
        value: 4, label: '4.消防水带产品', children: [
            {
                value: 1, label: '1.有衬里消防水带(自愿性认证产品)', children: [
                    {value: 1, label: '1.有衬里消防水带(自愿性认证产品)'},
                    {value: 2, label: '2.消防湿水带'},
                    {value: 3, label: '3.消防水幕水带'},
                ]
            },
            {
                value: 2, label: '2.消防软管卷盘(自愿性认证产品)', children: [
                    {value: 1, label: '1.消防软管卷盘(自愿性认证产品)'},
                ]
            },
            {
                value: 3, label: '3.消防吸水胶管(自愿性认证产品)', children: [
                    {value: 1, label: '1.消防吸水胶管(自愿性认证产品)'},
                ]
            },
            {
                value: 4, label: '4.轻便消防水龙', children: [
                    {value: 1, label: '1.轻便消防水龙'},
                ]
            },
        ]
    },
    {
        value: 5, label: '5.灭火器', children: [
            {
                value: 1, label: '1.手提式灭火器(强制性认证产品)', children: [
                    {value: 1, label: '1.手提式水基型灭火器'},
                    {value: 2, label: '2.手提式干粉灭火器'},
                    {value: 3, label: '3.手提式二氧化碳灭火器'},
                    {value: 4, label: '4.手提式洁净气体灭火器'},
                ]
            },
            {
                value: 2, label: '2.推车式灭火器(强制性认证产品)', children: [
                    {value: 1, label: '1.推车式水基型灭火器'},
                    {value: 2, label: '2.推车式干粉灭火器'},
                    {value: 3, label: '3.推车式二氧化碳灭火器'},
                    {value: 4, label: '4.推车式洁净气体灭火器'},
                ]
            },
            {
                value: 3, label: '3.简易式灭火器(强制性认证产品)', children: [
                    {value: 1, label: '1.简易式水基型灭火器'},
                    {value: 2, label: '2.简易式干粉灭火器'},
                    {value: 3, label: '3.简易式氢氟烃类气体灭火器'},
                ]
            },
            {
                value: 4, label: '4.其他类灭火器(技术鉴定产品)', children: [
                    {value: 1, label: '1.投掷型灭火瓶(技术鉴定产品)'},
                ]
            },
        ]
    },

    {
        value: 6, label: '6.灭火剂', children: [
            {
                value: 1, label: '1.气体灭火剂(自愿性认证产品)', children: [
                    {value: 1, label: '1.二氧化碳灭火剂(自愿性认证产品)'},
                    {value: 2, label: '2.七氟丙烷（HFC227ea）灭火剂(自愿性认证产品)'},
                    {value: 3, label: '3.六氟丙烷（HFC236fa）灭火剂(自愿性认证产品)'},
                    {value: 4, label: '4.卤代烃灭火剂'},
                    {value: 5, label: '5.惰性气体灭火剂'},
                ]
            },
            {
                value: 2, label: '2.泡沫灭火剂(自愿性认证产品)', children: [
                    {value: 1, label: '1.泡沫灭火剂(自愿性认证产品)'},
                    {value: 2, label: '2.A类泡沫灭火剂(自愿性认证产品)'},
                ]
            },
            {
                value: 3, label: '3.干粉灭火剂(自愿性认证产品)', children: [
                    {value: 1, label: '1.BC干粉灭火剂(自愿性认证产品)'},
                    {value: 2, label: '2.ABC干粉灭火剂(自愿性认证产品)'},
                    {value: 3, label: '3.BC超细干粉灭火剂(自愿性认证产品)'},
                    {value: 4, label: '4.ABC超细干粉灭火剂(自愿性认证产品)'},
                    {value: 5, label: '5.D类干粉灭火剂'},
                ]
            },
            {
                value: 4, label: '4.水系灭火剂(自愿性认证产品)', children: [
                    {value: 1, label: '1.水系灭火剂(自愿性认证产品)'},
                    {value: 2, label: '2.F类火灾水系灭火剂'},
                ]
            },
            {
                value: 5, label: '5.其他类灭火剂(技术鉴定产品)', children: [
                    {value: 1, label: '1.全氟己酮灭火剂(技术鉴定产品)'},
                ]
            },
        ]
    },
    {
        value: 7, label: '7.消防给水设备产品', children: [
            {
                value: 1, label: '1.消防泵(自愿性认证产品)', children: [
                    {value: 1, label: '1.车用消防泵(自愿性认证产品)'},
                    {value: 2, label: '2.消防球阀(自愿性认证产品)'},
                    {value: 3, label: '3.消防泵组(自愿性认证产品)'},
                ]
            },
            {
                value: 2, label: '2.固定消防给水设备(自愿性认证产品)', children: [
                    {value: 1, label: '1.消防气压给水设备'},
                    {value: 2, label: '2.消防自动恒压给水设备'},
                    {value: 3, label: '3.消防增压稳压给水设备'},
                    {value: 4, label: '4.消防气体顶压给水设备'},
                    {value: 5, label: '5.消防双动力给水设备'},
                ]
            },

            {
                value: 3, label: '3.消火栓(自愿性认证产品)', children: [
                    {value: 1, label: '1.室内消火栓(自愿性认证产品)'},
                    {value: 2, label: '2.室外消火栓(自愿性认证产品)'},
                    {value: 3, label: '3.消防水鹤(自愿性认证产品)'},
                    {value: 4, label: '4.消火栓箱'},
                    {value: 5, label: '5.消火栓扳手'},
                    {value: 6, label: '6.消火栓连接器'},
                ]
            },
            {
                value: 4, label: '4.消防水泵接合器(自愿性认证产品)', children: [
                    {value: 1, label: '1.地上式消防水泵接合器'},
                    {value: 2, label: '2.地下式消防水泵接合器'},
                    {value: 3, label: '3.墙壁式消防水泵接合器'},
                    {value: 4, label: '4.多用式消防水泵接合器'},
                    {value: 5, label: '5.沟槽连接式消防水泵接合器(技术鉴定产品)'},
                ]
            },
            {
                value: 5, label: '5.分集水器(自愿性认证产品)', children: [
                    {value: 1, label: '1.分水器(自愿性认证产品)'},
                    {value: 2, label: '2.集水器(自愿性认证产品)'},
                ]
            },
            {
                value: 6, label: '6.消防接口(自愿性认证产品)', children: [
                    {value: 1, label: '1.内扣式消防接口'},
                    {value: 2, label: '2.卡式消防接口'},
                    {value: 3, label: '3.螺纹式消防接口'},
                    {value: 4, label: '4.螺纹接口'},
                ]
            },
            {
                value: 7, label: '7.消防枪(自愿性认证产品)', children: [
                    {value: 1, label: '1.直流消防水枪(自愿性认证产品)'},
                    {value: 2, label: '2.喷雾消防水枪(自愿性认证产品)'},
                    {value: 3, label: '3.直流喷雾消防水枪(自愿性认证产品)'},
                    {value: 4, label: '4.多用消防水枪(自愿性认证产品)'},
                    {value: 5, label: '5.脉冲气压喷雾水枪(自愿性认证产品)'},
                    {value: 6, label: '6.泡沫枪(自愿性认证产品)'},
                    {value: 7, label: '7.干粉枪(自愿性认证产品)'},
                ]
            },
            {
                value: 8, label: '8.消防炮(自愿性认证产品)', children: [
                    {value: 1, label: '1.消防水炮'},
                    {value: 2, label: '2.消防泡沫炮'},
                    {value: 3, label: '3.消防泡沫-水两用炮'},
                    {value: 4, label: '4.消防干粉炮'},
                    {value: 5, label: '5.消防组合炮'},
                    {value: 6, label: '6.脉冲消防水炮和拖车移动式消防炮'},
                    {value: 7, label: '7.远程消防炮系统'},
                ]
            },
        ]
    },

    {
        value: 8, label: '8.喷水灭火设备产品', children: [
            {
                value: 1, label: '1.喷头(自愿性认证产品)', children: [
                    {value: 1, label: '1.洒水喷头(自愿性认证产品)'},
                    {value: 2, label: '2.水雾喷头(自愿性认证产品)'},
                    {value: 3, label: '3.早期抑制快速响应（ESFR）喷(自愿性认证产品)'},
                    {value: 4, label: '4.头扩大覆盖面积洒水喷头(自愿性认证产品)'},
                    {value: 5, label: '5.家用喷头(自愿性认证产品)'},
                    {value: 6, label: '6.水幕喷头(自愿性认证产品)'},
                ]
            },
            {
                value: 2, label: '2.报警阀(自愿性认证产品)', children: [
                    {value: 1, label: '1.湿式报警阀(自愿性认证产品)'},
                    {value: 2, label: '2.干式报警阀(自愿性认证产品)'},
                    {value: 3, label: '3.雨淋报警阀(自愿性认证产品)'},
                ]
            },
            {
                value: 3, label: '3.水流指示器(自愿性认证产品)', children: [
                    {value: 1, label: '1.水流指示器(自愿性认证产品)'},
                ]
            },
            {
                value: 4, label: '4.压力开关(自愿性认证产品)', children: [
                    {value: 1, label: '1.压力开关(自愿性认证产品)'},
                ]
            },
            {
                value: 5, label: '5.消防通用阀门(自愿性认证产品)', children: [
                    {value: 1, label: '1.消防闸阀(自愿性认证产品)'},
                    {value: 2, label: '2.消防球阀(自愿性认证产品)'},
                    {value: 3, label: '3.消防蝶阀(自愿性认证产品)'},
                    {value: 4, label: '4.消防电磁阀(自愿性认证产品)'},
                    {value: 5, label: '5.消防信号蝶阀(自愿性认证产品)'},
                    {value: 6, label: '6.消防信号闸阀(自愿性认证产品)'},
                    {value: 7, label: '7.消防截止阀(自愿性认证产品)'},
                ]
            },
            {
                value: 6, label: '6.感温元件(自愿性认证产品)', children: [
                    {value: 1, label: '1.自动灭火系统用玻璃球(自愿性认证产品)'},
                    {value: 2, label: '2.消防用易熔合金元件(自愿性认证产品)'},
                ]
            },
            {
                value: 7, label: '7.预作用装置(自愿性认证产品)', children: [
                    {value: 1, label: '1.预作用装置(自愿性认证产品)'},
                ]
            },
            {
                value: 8, label: '8.减压阀(自愿性认证产品)', children: [
                    {value: 1, label: '1.减压阀(自愿性认证产品)'},
                ]
            },
            {
                value: 9, label: '9.加速器(自愿性认证产品)', children: [
                    {value: 1, label: '1.加速器(自愿性认证产品)'},
                ]
            },
            {
                value: 10, label: '10.末端试水装置(自愿性认证产品)', children: [
                    {value: 1, label: '1.末端试水装置(自愿性认证产品)'},
                ]
            },
            {
                value: 11, label: '11.管道及连接件(自愿性认证产品)', children: [
                    {value: 1, label: '1.消防洒水软管(自愿性认证产品)'},
                    {value: 2, label: '2.沟槽式管接件(自愿性认证产品)'},
                ]
            },
            {
                value: 12, label: '12.自动跟踪定位射流灭火装置(自愿性认证产品)', children: [
                    {value: 1, label: '1.自动跟踪定位射流灭火装置(自愿性认证产品)'},
                ]
            },
            {
                value: 13, label: '13.细水雾灭火装置(自愿性认证产品)', children: [
                    {value: 1, label: '1.细水雾灭火装置(自愿性认证产品)'},
                ]
            },
            {
                value: 14, label: '14.其他喷水灭火装置(技术鉴定产品)', children: [
                    {value: 1, label: '1.专用喷淋灭火装置(技术鉴定产品)'},
                ]
            },
        ]
    },

    {
        value: 9, label: '9.泡沫灭火设备产品', children: [
            {
                value: 1, label: '1.泡沫发生装置(自愿性认证产品)', children: [
                    {value: 1, label: '1.低倍数空气泡沫产生器(自愿性认证产品)'},
                    {value: 2, label: '2.中倍数泡沫产生器(自愿性认证产品)'},
                    {value: 3, label: '3.高倍数泡沫产生器(自愿性认证产品)'},
                    {value: 4, label: '4.高背压泡沫产生器(自愿性认证产品)'},
                ]
            },
            {
                value: 2, label: '2.泡沫喷射装置(自愿性认证产品)', children: [
                    {value: 1, label: '1.泡沫炮(自愿性认证产品)'},
                    {value: 2, label: '2.泡沫枪(自愿性认证产品)'},
                    {value: 3, label: '3.泡沫钩管(自愿性认证产品)'},
                    {value: 4, label: '14.泡沫喷头(自愿性认证产品)'},
                ]
            },
            {
                value: 3, label: '3.泡沫混合装置(自愿性认证产品)', children: [
                    {value: 1, label: '1.压力式比例混合装置(自愿性认证产品)'},
                    {value: 2, label: '2.平衡式比例混合装置(自愿性认证产品)'},
                    {value: 3, label: '3.管线式比例混合器(自愿性认证产品)'},
                    {value: 4, label: '4.环泵式比例混合器(自愿性认证产品)'},
                ]
            },
            {
                value: 4, label: '4.泡沫液泵(自愿性认证产品)', children: [
                    {value: 1, label: '1.泡沫液泵(自愿性认证产品)'},
                ]
            },
            {
                value: 5, label: '5.专用阀门及附件(自愿性认证产品)', children: [
                    {value: 1, label: '1.泡沫消火栓(自愿性认证产品)'},
                    {value: 2, label: '2.连接软管(自愿性认证产品)'},
                ]
            },
            {
                value: 6, label: '6.泡沫消火栓箱(自愿性认证产品)', children: [
                    {value: 1, label: '1.泡沫消火栓箱(自愿性认证产品)'},
                ]
            },
            {
                value: 7, label: '7.轻便式泡沫灭火装置(自愿性认证产品)', children: [
                    {value: 1, label: '1.半固定式（轻便式）泡沫灭火装置(自愿性认证产品)'},
                ]
            },
            {
                value: 8, label: '8.闭式泡沫-水喷淋装置(自愿性认证产品)', children: [
                    {value: 1, label: '1.闭式泡沫-水喷淋装置(自愿性认证产品)'},
                ]
            },
            {
                value: 9, label: '9.厨房设备灭火装置(自愿性认证产品)', children: [
                    {value: 1, label: '1.厨房设备灭火装置(自愿性认证产品)'},
                    {value: 2, label: '2.探火管式厨房设备灭火装置'},
                ]
            },
            {
                value: 10, label: '10.泡沫喷雾灭火装置(自愿性认证产品)', children: [
                    {value: 1, label: '1.泡沫喷雾灭火装置(自愿性认证产品)'},
                ]
            },
            {
                value: 11, label: '11.其他泡沫灭火装置', children: [
                    {value: 1, label: '1.七氟丙烷泡沫灭火装置'},
                    {value: 2, label: '2.压缩空气泡沫灭火系统'},
                ]
            },
        ]
    },

    {
        value: 10, label: '10.气体灭火设备产品', children: [
            {
                value: 1, label: '1.高压二氧化碳灭火设备(自愿性认证产品)', children: [
                    {value: 1, label: '1.高压二氧化碳灭火设备(自愿性认证产品)'},
                ]
            },
            {
                value: 2, label: '2.低压二氧化碳灭火设备(自愿性认证产品)', children: [
                    {value: 1, label: '1.低压二氧化碳灭火设备(自愿性认证产品)'},
                ]
            },
            {
                value: 3, label: '3.卤代烷烃灭火设备(自愿性认证产品)', children: [
                    {value: 1, label: '1.卤代烷烃灭火设备(自愿性认证产品)'},
                ]
            },
            {
                value: 4, label: '4.惰性气体灭火设备(自愿性认证产品)', children: [
                    {value: 1, label: '1.惰性气体灭火设备(自愿性认证产品)'},
                ]
            },
            {
                value: 5, label: '5.悬挂式气体灭火装置(自愿性认证产品)', children: [
                    {value: 1, label: '1.悬挂式卤代烷烃灭火装置(自愿性认证产品)'},
                ]
            },
            {
                value: 6, label: '6.柜式气体灭火装置(自愿性认证产品)', children: [
                    {value: 1, label: '1.柜式卤代烷烃灭火装置'},
                    {value: 2, label: '2.柜式惰性气体灭火装置'},
                    {value: 3, label: '3.柜式二氧化碳灭火装置'},
                ]
            },
            {
                value: 7, label: '7.油浸变压器排油注氮灭火装置(自愿性认证产品)', children: [
                    {value: 1, label: '1.油浸变压器排油注氮灭火装置(自愿性认证产品)'},
                ]
            },
            {
                value: 8, label: '8.气溶胶灭火装置(自愿性认证产品)', children: [
                    {value: 1, label: '1.热气溶胶灭火装置(自愿性认证产品)'},
                ]
            },
            {
                value: 9, label: '9.感温自启动灭火装置(自愿性认证产品)', children: [
                    {value: 1, label: '1.七氟丙烷感温自启动灭火装置(自愿性认证产品)'},
                    {value: 2, label: '2.二氧化碳感温自启动灭火装置(自愿性认证产品)'},
                ]
            },
            {
                value: 10, label: '10.其他气体灭火装置', children: [
                    {value: 1, label: '1.电动车锂电池（箱）火灾防控产品（火灾抑制装着）(技术鉴定产品)'},
                    {value: 2, label: '2.外贮压式七氟丙烷灭火系统(技术鉴定产品)'},
                    {value: 3, label: '3.气体类探火管式灭火装置'},
                    {value: 4, label: '4.注氮控氧防火装置'},
                ]
            },
        ]
    },
    {
        value: 11, label: '11.干粉灭火设备产品', children: [
            {
                value: 1, label: '1.干粉灭火设备(自愿性认证产品)', children: [
                    {value: 1, label: '1.干粉灭火设备(自愿性认证产品)'},
                ]
            },
            {
                value: 2, label: '2.柜式干粉灭火装置(自愿性认证产品)', children: [
                    {value: 1, label: '1.柜式干粉灭火装置(自愿性认证产品)'},
                ]
            },
            {
                value: 3, label: '3.悬挂式干粉灭火装置(自愿性认证产品)', children: [
                    {value: 1, label: '1.悬挂式干粉灭火装置(自愿性认证产品)'},
                ]
            },
            {
                value: 4, label: '4.其他干粉灭火装置', children: [
                    {value: 1, label: '1.电动车锂电池（箱）火灾防控产品（火灾抑制装着）(技术鉴定产品)'},
                    {value: 2, label: '2.干粉类探火管式灭火装置'},
                ]
            },
        ]
    },
    {
        value: 12, label: '12.消防防烟排烟设备产品', children: [
            {
                value: 1, label: '1.防火排烟阀门(自愿性认证产品)', children: [
                    {value: 1, label: '1.防火阀(自愿性认证产品)'},
                    {value: 2, label: '2.排烟防火阀(自愿性认证产品)'},
                    {value: 3, label: '3.排烟阀(自愿性认证产品)'},
                ]
            },
            {
                value: 2, label: '2.消防排烟风机(自愿性认证产品)', children: [
                    {value: 1, label: '1.轴流式消防排烟风机'},
                    {value: 2, label: '2.离心式消防排烟风机'},
                ]
            },
            {
                value: 3, label: '3.挡烟垂壁(自愿性认证产品)', children: [
                    {value: 1, label: '1.活动式挡烟垂壁'},
                    {value: 2, label: '2.固定式挡烟垂壁'},
                ]
            },
        ]
    },
    {
        value: 13, label: '13.逃生避难产品', children: [
            {
                value: 1, label: '1.消防应急照明和疏散指示装置(强制性认证产品)', children: [
                    {value: 1, label: '1.消防应急标志灯具(强制性认证产品)'},
                    {value: 2, label: '2.消防应急照明灯具(强制性认证产品)'},
                    {value: 3, label: '3.应急照明控制器(强制性认证产品)'},
                    {value: 4, label: '4.应急照明集中电源(强制性认证产品)'},
                    {value: 5, label: '5.应急照明配电箱(强制性认证产品)'},
                    {value: 6, label: '6.应急照明分配电装置(强制性认证产品)'},
                ]
            },
            {
                value: 2, label: '2.消防安全标志(强制性认证产品)', children: [
                    {value: 1, label: '1.常规消防安全标志牌(强制性认证产品)'},
                    {value: 2, label: '2.蓄光消防安全标志牌(强制性认证产品)'},
                    {value: 3, label: '3.逆反射消防安全标志牌(强制性认证产品)'},
                    {value: 4, label: '4.荧光消防安全标志牌(强制性认证产品)'},
                    {value: 5, label: '5.其他消防安全标志牌(强制性认证产品)'},
                ]
            },
            {
                value: 3, label: '3.自救呼吸器(强制性认证产品)', children: [
                    {value: 1, label: '1. 过滤式消防自救呼吸器(强制性认证产品)'},
                    {value: 2, label: '2. 化学氧消防自救呼吸器(强制性认证产品)'},
                ]
            },
            {
                value: 4, label: '4.逃生产品(强制性认证产品)', children: [
                    {value: 1, label: ' 1.逃生缓降器(强制性认证产品)'},
                    {value: 2, label: ' 2.逃生梯(强制性认证产品)'},
                    {value: 3, label: ' 3.逃生滑道(强制性认证产品)'},
                    {value: 4, label: ' 4.应急逃生器(强制性认证产品)'},
                    {value: 5, label: ' 5.逃生绳(强制性认证产品)'},
                    {value: 6, label: ' 6.逃生舱'},
                    {value: 7, label: ' 7.推闩式逃生门锁'},
                ]
            },
        ]
    },

    {
        value: 14, label: '14.建筑耐火构件产品', children: [
            {
                value: 1, label: '1.防火门(自愿性认证产品)', children: [
                    {value: 1, label: '1.钢质隔热防火门(自愿性认证产品)'},
                    {value: 2, label: '2.木质隔热防火门(自愿性认证产品)'},
                    {value: 3, label: '3.钢木质隔热防火门(自愿性认证产品)'},
                    {value: 4, label: '4.其他材质隔热防火门(自愿性认证产品)'},
                    {value: 5, label: '5.防火门闭门器(自愿性认证产品)'},
                    {value: 6, label: '6.防火锁(自愿性认证产品)'},
                ]
            },
            {
                value: 2, label: '2.防火窗(自愿性认证产品)', children: [
                    {value: 1, label: '1.钢质隔热防火窗(自愿性认证产品)'},
                    {value: 2, label: '2.木质隔热防火窗(自愿性认证产品)'},
                    {value: 3, label: '3.钢木复合隔热防火窗(自愿性认证产品)'},
                    {value: 4, label: '4.其他材质隔热防火窗(自愿性认证产品)'},
                ]
            },
            {
                value: 3, label: '3.防火玻璃(自愿性认证产品)', children: [
                    {value: 1, label: '1.隔热型防火玻璃(自愿性认证产品)'},
                    {value: 2, label: '2.防火玻璃非承重隔墙(自愿性认证产品)'},
                ]
            },
            {
                value: 4, label: '4.防火卷帘(自愿性认证产品)', children: [
                    {value: 1, label: '1.钢质防火卷帘(自愿性认证产品)'},
                    {value: 2, label: '2.钢质防火防烟卷帘(自愿性认证产品)'},
                    {value: 3, label: '3.特级防火卷帘(自愿性认证产品)'},
                    {value: 4, label: '4.防火卷帘用卷门机(自愿性认证产品)'},
                ]
            },
            {
                value: 5, label: '5.防火防烟安全门户(技术鉴定产品)', children: [
                    {value: 1, label: '1.防火防烟安全门户(技术鉴定产品)'},
                ]
            },
        ]
    },

    {
        value: 15, label: '15.火灾防护产品', children: [
            {
                value: 1, label: '1.防火涂料(自愿性认证产品)', children: [
                    {value: 1, label: '1.饰面型防火涂料(自愿性认证产品)'},
                    {value: 2, label: '2.钢结构防火涂料(自愿性认证产品)'},
                    {value: 3, label: '3.电缆防火涂料(自愿性认证产品)'},
                    {value: 4, label: '4.混凝土结构防火涂料(自愿性认证产品)'},
                ]
            },
            {
                value: 2, label: '2.防火封堵材料(自愿性认证产品)', children: [
                    {value: 1, label: '1.防火封堵材料(自愿性认证产品)'},
                    {value: 2, label: '2.防火膨胀密封件(自愿性认证产品)'},
                    {value: 3, label: '3.塑料管道阻火圈'},
                    {value: 4, label: '4.阻燃处理剂、灭火毯'},
                    {value: 5, label: '5.不燃无机复合板'},
                    {value: 6, label: '6.防火刨花板'},
                    {value: 7, label: '7.隧道防火保护板'},
                ]
            },
            {
                value: 3, label: '3.耐火电缆槽盒', children: [
                    {value: 1, label: '1.耐火电缆槽盒'},
                    {value: 2, label: '2.电缆用阻燃包带'},
                ]
            },
            {
                value: 4, label: '4.阻火抑爆装置', children: [
                    {value: 1, label: '1.机动车排气火花熄灭器(自愿性认证产品)'},
                    {value: 2, label: '2.石油气体管道阻火器'},
                    {value: 3, label: '3.石油储罐阻火器'},
                ]
            },
        ]
    },
    {
        value: 16, label: '16.消防通信设备产品', children: [
            {
                value: 1, label: '1.火警受理设备(自愿性认证产品)', children: [
                    {value: 1, label: '1.火警调度机(自愿性认证产品)'},
                    {value: 2, label: '2.火警数字录音录时装置(自愿性认证产品)'},
                    {value: 3, label: '3.火警受理信息设备(自愿性认证产品)'},
                    {value: 4, label: '4.火警受理联动控制装置'},
                ]
            },
            {
                value: 2, label: '2.消防车辆动态管理装置(自愿性认证产品)', children: [
                    {value: 1, label: '1.消防车辆动态终端机(自愿性认证产品)'},
                    {value: 2, label: '2.消防车辆动态管理中心收发装置(自愿性认证产品)'},
                    {value: 3, label: '3.消防车上装系统控制器'},
                ]
            },
            {
                value: 3, label: '3.消防指挥调度设备', children: [
                    {value: 1, label: '1.火场通信控制台'},
                    {value: 2, label: '2.消防用无线电话机'},
                    {value: 3, label: '3.消防话音通信组网管理平台'},
                    {value: 4, label: '4.消防员单兵通信设备'},
                    {value: 5, label: '5.消防卫星通信系统便携式卫星站'},
                ]
            },
        ]
    },
    {
        value: 17, label: '17.无', children: [
            {
                value: 1, label: '无', children: [
                    {value: 1, label: '无'},
                ]
            },
        ]
    }
]


//社保员工人数
export const sheBaoNumberList = [
    {value: '', label: '全部'},
    {value: 1, label: '10人以内'},
    {value: 2, label: '10人—50人'},
    {value: 3, label: '50-100人'},
    {value: 4, label: '100人以上'},
]

//会员年限
export const vipYearList = [
    {value: '', label: '全部'},
    {value: 1, label: '一年'},
    {value: 2, label: '一年-三年'},
    {value: 3, label: '三年以上'},
]

//近三年大型经营项目数量（包含消防技术服务、电气防火检测、排油烟设施清洗、消防设计与施工、消防宣传教育培训、消防信息化建设、消防产品等业务项目）
export const bigNumList = [
    {value: '', label: '全部'},
    {value: 1, label: '100个以下'},
    {value: 2, label: '100-500个'},
    {value: 3, label: '500个以上'},
    // {value: 0, label: '无（新公司，暂未开展业务）'},
]
//近三年消防行业营业收入
export const ysMoneyList = [
    {value: '', label: '全部'},
    {value: 1, label: '100万元以下'},
    {value: 2, label: '100-1000万元'},
    {value: 3, label: '1000万元以上'},
    {value: 0, label: '无'},
]
//政府服务经验（为政府机关、事业单位等服务的项目数量）
export const serviceNumList = [
    {value: '', label: '全部'},
    {value: 1, label: '1-5个'},
    {value: 2, label: '5-10个'},
    {value: 3, label: '10个以上'},
    {value: 0, label: '无'},
]

//推荐发展会员情况
export const vipNumList = [
    {value: '', label: '全部'},
    {value: 1, label: '每年发展会员1-3个'},
    {value: 2, label: '每年发展会员3-5个'},
    {value: 3, label: '每年发展会员5-10个'},
    {value: 0, label: '无'},
]

export const stateList = [
    {value: '', label: '全部'},
    {value: 0, label: '否'},
    {value: 1, label: '是'}
]
export const hasList = [
    {value: '', label: '全部'},
    {value: 0, label: '无'},
    {value: 1, label: '有'}
]
//信用等级
export const creditLevelList = [{
    value: '', label: '全部',
    children: [{
        value: '',
        label: '全部'
    }]
}, {
    value: '',
    label: '优',
    children: [{
        value: 1,
        label: 'A'
    }, {
        value: 2,
        label: 'A-'
    }]
}, {
    value: '',
    label: '良',
    children: [{
        value: 3,
        label: 'B+'
    }, {
        value: 4,
        label: 'B'
    }, {
        value: 5,
        label: 'B-'
    }]
}, {
    value: '',
    label: '中',
    children: [{
        value: 6,
        label: 'C+'
    }, {
        value: 7,
        label: 'C'
    }, {
        value: 8,
        label: 'C-'
    }]
}, {
    value: '',
    label: '差',
    children: [{
        value: 9,
        label: 'D'
    }]
}]

export const browserRedirect = () => {   //  1 手机 2 pc
    var sUserAgent = navigator.userAgent.toLowerCase();
    var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    var bIsMidp = sUserAgent.match(/midp/i) == "midp";
    var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    var bIsAndroid = sUserAgent.match(/android/i) == "android";
    var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        return 1
    } else {
        return 2
    }
}

/*
 * 数据过滤全部
 * */
export const optionList = (state, arr) => {
    if (state) {
        return arr
    } else {
        return arr.slice(1)
    }
}

/*
 * 数据过滤全部
 * */
export const formatList = (arr) => {
    arr.map(item => {
        item.text = item.label
    })
    return arr
}
/*
 * 手机端数据过滤全部
 * */
export const formatListValue = (arr) => {
    arr.map(item => {
        if (item.value) item.value = item.label
    })
    return arr
}

/*
 * value转换为label
 * */
export const filesCN = (val, arr) => {
    let _str = arr.filter(item => val === item.value)
    if (_str.length === 0) return '--'
    return _str[0].label
}


/*
 * 时间转换
 * */
export const zhDate = (date, type) => {
    let now = new Date(date)
    let year = now.getFullYear()
    let month = now.getMonth() + 1
    let day = now.getDate()
    let hour = now.getHours()
    let minute = now.getMinutes()
    let second = now.getSeconds()
    if (type === 1) {
        return year + "-" + getzf(month) + "-" + getzf(day) + "  " + getzf(hour) + ":" + getzf(minute)
    } else if (type === 2) {
        return year + "-" + getzf(month) + "-" + getzf(day) + "  " + getzf(hour) + ":" + getzf(minute) + ":" + getzf(second)
    } else if (type === 3) {
        return getzf(hour) + ":" + getzf(minute)
    } else if (type === 4) {
        return year
    } else {
        return year + "-" + getzf(month) + "-" + getzf(day)
    }
}

function getzf(num) {
    if (parseInt(num) < 10) {
        num = '0' + num
    }
    return num
}


export const zhRmb = (num) => {
    if (Number(num) > 10000) {
        return (Number(num) / 10000).toFixed(2) + '万元'
    } else {
        return num + '元'
    }
}

export const _reduce = (arr) => {
    if (Array.isArray(arr)) {
        return arr.reduce((prev, item) => {
            return Array.isArray(item) ? prev.concat(_reduce(item)) : prev.concat(item)
        }, [])
    } else {
        throw new Error("arr + ' is not array'")
    }
}